module.exports = __webpack_public_path__ + "img/580-42dfb3.png";